import React, { Component } from "react";
import Rail from "../../components/shared/Rail";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { compose, bindActionCreators } from "redux";
import { VideoListingComponent } from "./videosListing";
import ExpertHorizontalWideCard from "../../components/followManagement/ExpertHorizontalWideCard";
import OwlCrousel from "../../components/shared/OwlCrousel";
import { LoaderComponent } from "../../components/loader";
import HelmetComponent from "../../components/shared/Helmet";
import {
    getSeriesDetailAction,
    getSeriesVods,
    showLoader,
    hideLoader,
    setSignupModalStatus
} from "../../actions";
import {
    getParameterByName,
    getLastInputFromUrl,
    redirectToUrl,
    followButtonClicked,
    unFollowButtonClicked,
    IsEmpty,
    convertToSlug,
    generateStructuredData
} from "../../util/commonFunctions";
import cosmeticConfig from '../../../config/cosmeticConfig';


class Series extends Component {
    constructor(props) {
        super(props);

        this.state = {
            options: {
                margin: 15,
                rewind: false,
                autoplay: false,
                dots: false,
                loop: false,
                responsive: {
                    992: {
                        items: 4,
                        slideBy: 4,
                        nav: true
                    },
                    768: {
                        items: 3,
                        slideBy: 3,
                        nav: true
                    },
                    480: {
                        items: 2,
                        slideBy: 2,
                        nav: false
                    },
                    320: {
                        items: 1,
                        slideBy: 1,
                        nav: false
                    }
                }
            },
            seriesDetail: this.props.seriesDetail ? this.props.seriesDetail : {},
            currentTab: "series_home",
            lastScrollTop: 0,
            offset: cosmeticConfig.series.OFFSET,
            max: cosmeticConfig.series.MAX,
            structuredData: null
        };
    }

    componentDidMount = () => {
        const { match: { url } = {}, location: { search } = {} } = this.props;
        let seriesID = getParameterByName("seriesID", search || url);
        if (seriesID) {
            console.log("SeriesID found...");
            this.getSeriesData(seriesID);
        } else {
            console.log("SeriesID not found, skipping GET");
        }
        this.lazyLoadContainer = React.createRef();
        window.addEventListener("scroll", this.onScroll, false); // bind scroll event
        // this.loadLazyImg();
    }

    componentDidUpdate(prevProps) {
        const {
            match: { url: newUrl },
            location: { search } = {}
        } = this.props;
        const {
            match: { url: oldUrl }
        } = prevProps;
        let seriesID = getParameterByName("seriesID", search);
        if (seriesID) {
            if (oldUrl !== newUrl) {
                this.getSeriesData(seriesID);
                this.resetSeriesState();
            }
        } else {  
             console.log("SeriesID not found, skipping GET");
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.seriesDetail != this.props.seriesDetail) {
            this.setState({
                seriesDetail: nextProps.seriesDetail
            });
        }
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.onScroll, false);
    }

    updateCurrentTab = (newTab) => {
        // this.setState({
        //     currentTab: newTab
        // }, () => {
        //     this.loadLazyImg();
        // });
        this.setState({
            currentTab: newTab
        });
    }

    resetSeriesState = () => {
        this.updateCurrentTab('series_home');
        this.setState({
            lastScrollTop: 0
        });
    }

    // loadLazyImg = () => {
    //     window.scrollTo(window.scrollX, window.scrollY + 1);
    //     window.scrollTo(window.scrollX, window.scrollY - 1);
    // }

    getSeriesData = id => {
        let token = localStorage.getItem("token");
        const language = this.props.currentLanguage;
        this.props.getSeriesDetailAction({ id, token, language });
        this.getVodListData(id);
    };

    followObject = (objectId, objectType) => {
        const isLoggedin = !IsEmpty(localStorage.getItem("token"))

        if (isLoggedin) {
            if (objectType == "company") {
                followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), objectId);
            } else if (objectType == "expert") {
                followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), null, null, objectId);
            } else if (objectType == "topic") {
                followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), null, objectId);
            } else if (objectType == "series") {
                followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), null, null, null, objectId);
            }
        } else {
            this.openSigninModalPopup("signin");
        }
    }

    unFollowObject = (objectId, objectType) => {
        if (objectType == "company") {
            unFollowButtonClicked(this.unFollowButtonClickedRespHandler, localStorage.getItem("token"), objectId);
        } else if (objectType == "expert") {
            unFollowButtonClicked(this.unFollowButtonClickedRespHandler, localStorage.getItem("token"), null, null, objectId);
        } else if (objectType == "topic") {
            unFollowButtonClicked(this.unFollowButtonClickedRespHandler, localStorage.getItem("token"), null, objectId);
        } else if (objectType == "series") {
            unFollowButtonClicked(this.unFollowButtonClickedRespHandler, localStorage.getItem("token"), null, null, null, objectId);
        }
    }

    followButtonClickedRespHandler = (response, error) => {
        this.updateFollowBtnStatus(response.objectId, response.objectType);
    }

    unFollowButtonClickedRespHandler = (response, error) => {
        this.updateFollowBtnStatus(response.objectId, response.objectType);
    }

    updateFollowBtnStatus = (objectId, objectType) => {
        if (objectType == "expert") {
            let updated_experts = [];
            Object.values(this.state.seriesDetail.experts).map(values => {
                if (values?.id == objectId) {
                    values.isFollowing = !values.isFollowing;
                }
                updated_experts.push(values);
            });
            this.setState(prevState => ({
                seriesDetail: {
                    ...prevState.seriesDetail,
                    experts: updated_experts
                }
            }))
        } else if (objectType == "series") {
            this.setState(prevState => ({
                seriesDetail: {
                    ...prevState.seriesDetail,
                    isFollowing: !prevState.seriesDetail.isFollowing
                }
            }))
        }
    }

    openSigninModalPopup = (formName = "signin") => {
        this.props.setSignupModalStatus(true, formName);
    };

    formattedAbout = (content) => {
        content = content.replace('<p><br></p>', '');
        content = content.replace(/<p/g, '<p class="description" ');
        content = content.replace(/<a/g, '<a class="custom_links_webinar" ');
        content = content.replace(/<li/g, '<li class="default_listing description" ');
        content = content.replace(/<ul/g, '<ul class="default_listing" ');
        content = content.replace(/<ol/g, '<ol class="default_listing" ');
        content = content.replace(/<img/g, '<img class="responsive-img" ');
        return {
            __html: content
        };
    };

    ///  lazy load on scroll
    onScroll = () => {
        if (this.state.currentTab == 'series_videos') {
            let seriesId = this.getSeriesID();
            const {
                lastScrollTop
            } = this.state
            const {
                top: containerTop
            } = this.lazyLoadContainer.current.getBoundingClientRect();
            var st = window.pageYOffset || document.documentElement.scrollTop;
            if (st > lastScrollTop) {
                this.setState({
                    lastScrollTop: st <= 0 ? 0 : st
                })
                // downscroll code
            } else {
                this.setState({
                    lastScrollTop: st <= 0 ? 0 : st
                })
                return;
                // upscroll code
            }
            if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 200) {
                const listing =
                    this.props.seriesVods &&
                    Object.values(this.props.seriesVods).map(values => values);
                const lastList =
                    Array.isArray(listing) && listing.length && listing[listing.length - 1];
                const totalCount =
                    this.props.seriesVods &&
                    Object.values(this.props.seriesVods).map(values => values.totalCount);
                if (!this.props.isSeriesVodsLoading && containerTop < 100 && lastList.length && this.state.offset <= totalCount) {
                    this.setState(
                        prevState => ({
                            offset: prevState.offset + prevState.max
                        }),
                        () => {
                            this.getVodListData(seriesId);
                        }
                    );
                }
            }
        }
    };

    getSeriesID = () => {
        const {
            location: { search } = {}
        } = this.props;
        let seriesID = getParameterByName("seriesID", search);
        if (!seriesID || seriesID == null) {
            seriesID = getLastInputFromUrl(search);
        }
        return seriesID;
    }

    getVodListData = id => {
        const { max, offset } = this.state;
        const { getSeriesVods, currentLanguage } = this.props;
        let token = localStorage.getItem("token");
        getSeriesVods({ id, offset, max, token, language: currentLanguage });
    };


    render() {

        let totalResults = 0;
        const listing =
            this.props.seriesVods &&
            Object.values(this.props.seriesVods).map(values => {
                totalResults += values
                    ? values.length
                    : 0;
                return values;
            });

        const structuredData = (this.props.seriesVods && this.props.seriesVods[0] && this.props.seriesVods[0].length > 0) && generateStructuredData(this.props.seriesVods[0])
        if(structuredData) this.state.structuredData = `{"@context":"https://schema.org", "@graph": [${structuredData}]}`

        return (
            <React.Fragment>
                <HelmetComponent
                    title={this.state.seriesDetail && this.state.seriesDetail.name + " | ausbiz"}
                    subject={this.state.seriesDetail && this.state.seriesDetail.name}
                    customDescription={this.state.seriesDetail.shortDescription}
                    structuredData={this.state.structuredData}
                    noIndex="false"
                />

                {this.state.seriesDetail && 
                <div className="content-trade">
                    <div className="trade-header-block">
                        <div className="container">
                            <div className="flex">
                                <div className="image-block">
                                    {!IsEmpty(this.state.seriesDetail.logoUrl) &&
                                        <img src={this.state.seriesDetail.logoUrl} />
                                    }
                                    {IsEmpty(this.state.seriesDetail.logoUrl) &&
                                        <img src="/assets/ausbiz_series_logo.png" />
                                    }
                                </div>
                                <div className="trade-right">
                                    <h2>{this.state.seriesDetail.name}</h2>
                                    <p>{this.state.seriesDetail.shortDescription}</p>
                                    {this.state.seriesDetail.schedule &&
                                        <span className="weekdays"><i></i> {this.state.seriesDetail.schedule}</span>
                                    }
                                    <div className="tardelist">
                                        <div className="watch-follow">
                                            {this.props.seriesVods && !IsEmpty(this.props.seriesVods[0]) &&
                                                <div className="watch-list">
                                                    <Link
                                                        to={
                                                            "/media/" +
                                                            convertToSlug(this.props.seriesVods[0][0].title) +
                                                            "?videoId=" +
                                                            this.props.seriesVods[0][0].id
                                                        }
                                                    >
                                                        <span></span>
                                                        <strong>Watch latest</strong>
                                                    </Link>
                                                </div>
                                            }


                                            {this.state.seriesDetail.isFollowing ?
                                                (
                                                    <div className="follow-list follow-list-gray" onClick={() => this.unFollowObject(this.state.seriesDetail.id, "series")}>
                                                        <span></span>
                                                        <strong>Following</strong>
                                                    </div>
                                                ) : (
                                                    <div className="follow-list" onClick={() => this.followObject(this.state.seriesDetail.id, "series")}>
                                                        <span></span>
                                                        <strong>Follow</strong>
                                                    </div>
                                                )

                                            }

                                        </div>
                                        <ul className="product-list">
                                            {this.state.seriesDetail.topics && this.state.seriesDetail.topics.map((topic, topicIndex) => {
                                                return (
                                                    <a
                                                        href={`/expert/${topic.name}/${topic.id}`}
                                                        onClick={event => {
                                                            redirectToUrl(
                                                                event,
                                                                topic.id,
                                                                this.props,
                                                                this.props.showLoader,
                                                                this.props.hideLoader,
                                                                this.props.currentLanguage
                                                            )
                                                        }
                                                        }
                                                        key={`seriesRelatedTopics-${topicIndex}`}
                                                    >
                                                        <li key={`topic-${topicIndex}`}>{topic.name}</li>
                                                    </a>
                                                );
                                            })

                                            }
                                        </ul>
                                    </div>
                                    <div className="follow-mgmnt-tabs">
                                        <ul>
                                            <li data-id="companies-tab" className={this.state.currentTab == "series_home" ? "follow-mgmnt-tab active" : "follow-mgmnt-tab"} onClick={() => this.updateCurrentTab("series_home")}>Home</li>
                                            {this.props.seriesVods && !IsEmpty(this.props.seriesVods[0]) &&
                                                <li data-id="topics-tab" className={this.state.currentTab == "series_videos" ? "follow-mgmnt-tab active" : "follow-mgmnt-tab"} onClick={() => this.updateCurrentTab("series_videos")}>Videos</li>
                                            }
                                            {!IsEmpty(this.state.seriesDetail.experts) &&
                                                <li data-id="experts-tab" className={this.state.currentTab == "series_experts" ? "follow-mgmnt-tab active" : "follow-mgmnt-tab"} onClick={() => this.updateCurrentTab("series_experts")}>Experts</li>
                                            }
                                            {!IsEmpty(this.state.seriesDetail.about) &&
                                                <li data-id="topics-tab" className={this.state.currentTab == "series_about" ? "follow-mgmnt-tab active" : "follow-mgmnt-tab"} onClick={() => this.updateCurrentTab("series_about")}>About</li>
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="trade-main-comtent">
                        {this.state.currentTab == "series_home" &&
                            <>
                                <Rail
                                    key="latest"
                                    theme="LIGHT"
                                    title="Latest"
                                    data={this.props.seriesVods ? this.props.seriesVods[0] : []}
                                    railType="latest_rail"
                                    showSeeAll={false}
                                    cstmSeeAll={this.updateCurrentTab}
                                />
                                {this.state.seriesDetail.experts && this.state.seriesDetail.experts.length > 0 &&
                                    <div className="rail_wrapper" key={`expertCarousel`}>
                                        <div className="container">
                                            <div className="home-tablist">
                                                <div className="regular-expert">
                                                    <div className="d-flex flex-row justify-content-between align-items-center">
                                                        <h2 className="text-left">Regular Experts</h2>
                                                        <span className="seeAll" onClick={() => this.updateCurrentTab("series_experts")}>See all</span>
                                                    </div>
                                                    <div className="expert-list-wrap railMobile text-center">
                                                        <OwlCrousel
                                                            crouselOption={this.state.options}
                                                            railType="experts"
                                                            data={this.state.seriesDetail.experts}
                                                            followObject={this.followObject}
                                                            unFollowObject={this.unFollowObject}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </>
                        }
                        {this.state.currentTab == "series_videos" &&
                            <section
                                className="container tier-listing"
                                ref={this.lazyLoadContainer}
                            >
                                <LoaderComponent isLoading={this.props.isSeriesVodsLoading} />
                                <div className="row">
                                    <VideoListingComponent
                                        listing={listing}
                                        totalResults={totalResults}
                                        isLoading={false}
                                    />
                                </div>
                            </section>
                        }
                        {this.state.currentTab == "series_experts" &&
                            <div className="container">
                                <div className="home-tablist" id="home-tablist">
                                    <ExpertHorizontalWideCard
                                        experts={this.state.seriesDetail.experts}
                                        followObject={this.followObject}
                                        unFollowObject={this.unFollowObject}
                                        parentProps={this.props}
                                    />
                                </div>
                            </div>
                        }
                        {this.state.currentTab == "series_about" &&
                            <div className="container">
                                <div className="home-tablist" dangerouslySetInnerHTML={this.formattedAbout(this.state.seriesDetail.about)}>
                                </div>
                            </div>
                        }

                    </div>
                </div>}
            
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        seriesDetail: state.seriesPage.seriesDetail,
        isSeriesDetailLoading: state.seriesPage.isSeriesDetailLoading,
        seriesVods: state.seriesPage.seriesVods,
        isSeriesVodsLoading: state.seriesPage.isSeriesVodsLoading,
        token: state.auth.token,
        currentLanguage: state.language.currentLanguage
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            getSeriesDetailAction,
            getSeriesVods,
            setSignupModalStatus: (status, requestedForm) => dispatch(setSignupModalStatus(status, requestedForm)),
            showLoader: () => dispatch(showLoader()),
            hideLoader: () => dispatch(hideLoader())
        },
        dispatch
    );
}

// Runs when refreshing a page
function loadData(store, match, query) {
    console.log("Running loadData");
    let seriesId = query.seriesID;
    const currentLanguage = store.getState().language.currentLanguage;
    let actionArray = [
        store.dispatch(getSeriesDetailAction({ id: seriesId, language: currentLanguage })),
        store.dispatch(getSeriesVods({ id: seriesId, offset: cosmeticConfig.series.OFFSET, max: cosmeticConfig.series.MAX, token: null, language: currentLanguage }))
    ];
    return actionArray;
}

export default {
    loadData,
    component: compose(
        withRouter,
        connect(mapStateToProps, mapDispatchToProps)
    )(Series)
};